import { reatomAsync } from '@reatom/async';

import { authAtom } from '../atoms/authAtom';

export const setReferrerIdAction = reatomAsync(
  async (ctx, referrerId: string) => {
    authAtom.set(ctx, 'referrerId', referrerId, {
      path: '/',
      maxAge: 86400,
    });
  },
  'setReferrerIdAction',
);
